import { render, staticRenderFns } from "./LPGReport.vue?vue&type=template&id=b1a974dc"
import script from "./LPGReport.vue?vue&type=script&lang=js"
export * from "./LPGReport.vue?vue&type=script&lang=js"
import style0 from "./LPGReport.vue?vue&type=style&index=0&id=b1a974dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports